import React, { FC } from "react";

import { useGetFlexDatesData } from "./useGetFlexDatesData";
import FlexibleDateBestPriceInner from "./FlexibleDateBestPriceInner";

const FlexibleDateBestPrice: FC = () => {
  const data = useGetFlexDatesData();
  if (!data) {
    return null;
  }

  const { dates, currentBestPrice, cheaperCount, isOneWay } = data;

  return (
    <FlexibleDateBestPriceInner
      carouselSize="large"
      dates={dates}
      currentBestPrice={currentBestPrice}
      cheaperCount={cheaperCount}
      isOneWay={isOneWay}
    />
  );
};

export default FlexibleDateBestPrice;
